// ── imports explicites (C4 — générés par esm-codemod --analyze, maintenus à la main) ──
import { useEffect } from "../00-boot.jsx";
import { rpcSetTimezone } from "../07-trust-moderation.jsx";
import { lanacSupabaseClient } from "../08-supabase-client.jsx";
// Fuseau horaire de l'utilisateur (pour les quiet hours serveur 22h-8h heure locale). Écriture
// via RPC set_timezone (SECURITY DEFINER => pas de souci de grant colonne sur profiles).
function useTimezoneSync(me){
  useEffect(()=>{
    const client=lanacSupabaseClient();
    if(!client||!me?.id) return;
    try{ const tz=Intl.DateTimeFormat().resolvedOptions().timeZone; if(tz){ const q=rpcSetTimezone(tz); q&&q.then&&q.then(undefined,()=>{}); } }catch(_){} // PREF-RPC-1 : passerelle
  },[me?.id]);
}
export { useTimezoneSync };
